import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { checkDomain } from './Classes/checkDomain';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  get isLoggedIn(): boolean {
    let token = localStorage.getItem('access_token');
    if (checkDomain() !== localStorage.getItem('domain')) {
      return false;
    };
    return token !== null ? true : false;
  }

  refreshToken(token: string) {   
    return this.http.post(environment.HTTP+ checkDomain()+'.'+environment.API_URL+'/api/refresh', {
      refresh_token: token,
      domain: checkDomain()
    },);
  }

  getUserID(){
    return localStorage.getItem("userID") ?? '';
  }

  getUserName(){
    return localStorage.getItem("userName") ?? '';
  }
}
